<!-- Hero -->
<section class="hero">
  <div class="hero-content">
    <span class="overline">Software Engineer</span>
    <h1 class="hero-title gradient-text">Joaquin 'highnet' Telleria</h1>
    <p class="hero-subtitle">
      Full-Stack &amp; Web3 Developer, UI/UX Designer, and Game Developer based
      in Vienna, Austria.
    </p>
    <div class="hero-cta">
      <button class="btn btn-primary" (click)="goToCV()">View CV</button>
      <a
        class="btn btn-ghost"
        href="https://github.com/highnet/highnet-cv"
        target="_blank"
        rel="noopener"
      >
        Source Code
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M7 17l9.2-9.2M17 17V7.8M17 7.8H7.8" />
        </svg>
      </a>
    </div>
  </div>
</section>

<!-- Featured Projects -->
<section class="projects-section">
  <div class="section-inner">
    <span class="section-overline">Featured Work</span>
    <h2 class="section-title">Projects &amp; Contributions</h2>
    <div class="projects-grid">
      @for (project of projects; track project.title) {
        <div class="project-card">
          <div class="card-header">
            <h3>
              @if (project.url) {
                <a
                  [href]="project.url"
                  target="_blank"
                  rel="noopener"
                  class="title-link"
                  >{{ project.title }}</a
                >
              } @else {
                {{ project.title }}
              }
            </h3>
            @if (project.url) {
              <a
                [href]="project.url"
                target="_blank"
                rel="noopener"
                class="arrow-link"
                aria-label="Visit project"
              >
                <svg
                  class="arrow"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M7 17l9.2-9.2M17 17V7.8M17 7.8H7.8" />
                </svg>
              </a>
            }
          </div>
          <p class="card-desc">{{ project.description }}</p>

          @if (project.links && project.links.length > 0) {
            <div class="project-links-list">
              @for (link of project.links; track link.url) {
                <a
                  [href]="link.url"
                  target="_blank"
                  rel="noopener"
                  class="sub-link"
                  >{{ link.label }}</a
                >
              }
            </div>
          }

          <div class="card-tags">
            @for (tag of project.tags; track tag) {
              <span class="tag">{{ tag }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- Stats -->
<section class="stats-section">
  <div class="stats-inner">
    <div class="stat">
      <span class="stat-number gradient-text">5+</span>
      <span class="stat-label">Years Experience</span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat">
      <span class="stat-number gradient-text">15+</span>
      <span class="stat-label">Projects Shipped</span>
    </div>
    <div class="stat-divider"></div>
    <div class="stat">
      <span class="stat-number gradient-text">30+</span>
      <span class="stat-label">Technologies</span>
    </div>
  </div>
</section>
